import { handleActions } from 'redux-actions';

import { Actions } from '../actions/studies';

const initialState = {
  lastFetched: null,
  loading: false,
  error: null,
  value: [],
};

export default handleActions(
  {
    [Actions.STUDIES_REQUEST]: state => ({
      ...state,
      loading: true,
      error: null,
      value: [],
    }),
    [Actions.STUDIES_SUCCESS]: (state, action) => ({
      ...state,
      loading: false,
      error: null,
      value: action.response.result,
    }),
    [Actions.STUDIES_FAILURE]: (state, action) => ({
      ...state,
      loading: false,
      error: action.error,
      value: [],
    }),
  },
  initialState
);
